export default "__VITE_ASSET__57392198__"